import React, { useState, useEffect, useMemo } from 'react';
import axios from "axios";
import Header from "../../../Sidebar/header";
import rupee from "../../../../assets/img/profiles/Rupee-Symbol-Black.svg";
// import rupee from "../../../../ass"
import Sidebar from "../../../Sidebar/sidebarAdmin";
import {
  Table,
  Modal,
  Card,
  Typography,
  Divider,
  TextField,
  Button,
  Box,
  Paper,
  CircularProgress,
  Alert
} from '@mui/material';
import { Table as AntTable } from 'antd';

// 🟢 1. Utility (keep outside component)
const getFinancialYear = (date = new Date()) => {
  const year = date.getFullYear();
  const month = date.getMonth(); // 0-11
  return month >= 3 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
};

// 🟢 2. Function (can stay outside too, but pass currentFY as param)
const generateFinancialYearOptions = (currentFY) => {
  const [startYear] = currentFY.split('-').map(Number);
  const options = Array.from({ length: 5 }, (_, i) => {
    const offset = i - 2;
    return `${startYear + offset}-${startYear + 1 + offset}`;
  });

  // Ensure currentFY is included (edge case)
  if (!options.includes(currentFY)) options.push(currentFY);
  return options.sort();
};

const EmployeeTaxDeclaration = () => {

  const currentFY = useMemo(() => getFinancialYear(), []);
  const [financialYear, setFinancialYear] = useState(currentFY);

  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const FinancialYearOptions = useMemo(() => generateFinancialYearOptions(currentFY), [currentFY]);
  const [menu, setMenu] = useState(false);
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/get_tax_decl_admin/`, {
          params: {
            financial_year: financialYear,
          }
        });

        // Extract the data array from response
        const responseData = response.data;

        // Ensure we always work with an array
        const employeesArray = Array.isArray(responseData) ? responseData : [responseData];

        // No need to add name fallback since name is now guaranteed to be present
        setEmployees(employeesArray);

      } catch (err) {
        console.error('Error fetching employee data:', err);

        if (err.response) {
          setError(`Server error: ${err.response.status} - ${err.response.statusText}`);
        } else if (err.request) {
          setError('No response from server. Check your network connection.');
        } else {
          setError(`Request setup error: ${err.message}`);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchEmployeeData();
  }, [financialYear]);

  const columns = [
    {
      title: 'Emp ID',
      dataIndex: 'empid',
      key: 'empid',
    },
    {
      title: 'Emp Name',
      key: 'name',
      render: (_, record) => {
        // Safely access the first name in empid_name array
        const employeeName = record.empid_name?.[0]?.name;
        return employeeName || 'N/A';
      }
    },
    {
      title: 'Age',
      dataIndex: ['section', 'age'],
      key: 'age',
      render: (age) => age ?? 'N/A'
    },
    {
      title: 'Annual TDS',
      dataIndex: 'annual_tds',
      key: 'annual_tds',
      render: (amount) => {
        if (amount === null || amount === undefined) return 'N/A';
        return `₹${amount}`; // This will show ₹0 for zero values
      }
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      render: (type) => {
        if (type === 'old') return 'Old Regime';
        if (type === 'new') return 'New Regime';
        return 'N/A';
      }
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setSelectedEmployee(record);
            setModalOpen(true);
          }}
          disabled={loading}
        >
          View Form
        </Button>
      ),
    },
  ];

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
        <Typography variant="body1" sx={{ ml: 2 }}>Loading employee data...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Error loading employee data: {error}
        </Alert>
        <Button
          variant="contained"
          sx={{ mt: 2 }}
          onClick={() => window.location.reload()}
        >
          Retry
        </Button>
      </Box>
    );
  }

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={(value) => toggleMobileMenu()} />

      <Sidebar />
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          {/* <div className="page-header"></div> */}
          <Box sx={{ padding: 3 }}>
            <Paper elevation={3} sx={{ padding: 3 }}>
              <Typography variant="h5" gutterBottom>
                Employee Tax Declarations
              </Typography>
              <div>
                <label>Financial Year:</label>
                <select
                  value={financialYear}
                  onChange={(e) => setFinancialYear(e.target.value)} // Fixed
                >
                  {FinancialYearOptions.map(fy => (
                    <option key={fy} value={fy}>{fy}</option>
                  ))}
                </select>
              </div>

              {/* <Typography variant="subtitle1" gutterBottom>
          Financial Year: 2023-2024
        </Typography> */}

              {employees.length > 0 ? (
                <AntTable
                  columns={columns}
                  dataSource={employees}
                  rowKey="empid"
                  bordered
                  pagination={{ pageSize: 10 }}
                />
              ) : (
                <Typography variant="body1" sx={{ mt: 2 }}>
                  No employee tax declarations found for this financial year.
                </Typography>
              )}
            </Paper>

            {/* Modal for viewing employee tax declaration */}
           // Inside your modal component where you render the tax declaration form
            <Modal
              open={modalOpen}
              onClose={() => setModalOpen(false)}
              aria-labelledby="tax-declaration-modal"
            >
              <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '80%',
                maxHeight: '90vh',
                overflowY: 'auto',
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
              }}>
                {selectedEmployee && (
                  <div className="container-fluid">
                    <Typography variant="h6" gutterBottom>
                      {/* Tax Declaration - {selectedEmployee.name || `Employee ${selectedEmployee.empid}`} */}
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom>
                      Financial Year: {selectedEmployee.financial_year}
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom>
                      Tax Regime: {selectedEmployee.type === 'old' ? 'Old Regime' : 'New Regime'}
                    </Typography>

                    {/* Salary Components */}
                    <div className="col-md-12">
                      <h4><b><u>Salary Components</u></b></h4>
                    </div>
                    <br />
                    <div className="contain">
                      {selectedEmployee.component?.map((comp) => (
                        <>
                          <div className="col-md-12">
                            {/* <label className="col-md-6">{comp.name}</label> */}
                            <label className="col-md-6">
                              {comp.name.charAt(0).toUpperCase() + comp.name.slice(1)}
                            </label>
                            <div className="col-md-3 tax-input" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                              <img src={rupee} className="rupee col-md-4" />
                              <input
                                type="text"
                                className="tax-i col-md-8"
                                disabled
                                value={comp.value || '0'}
                              />
                            </div>
                          </div>
                          <br /><br />
                        </>
                      ))}
                    </div>
                    <br /><br />

                    {/* 80C Deductions */}
                    <div className="col-md-12">
                      <h4><b><u>Section 80C Deductions (Max ₹1.5 Lakh)</u></b></h4>
                    </div>
                    <br />
                    <div className="contain">
                      {[
                        { label: "Life Insurance Premium Paid for yourself, spouse, or children", key: "insurancePremium_children" },
                        { label: "Repayment of Housing Loan (Principal Component)", key: "housingLoan_principalComponent" },
                        { label: "Other Investments Total", key: "NSC_tuitionFee_stampDuty_mutualFund_UTI_otherInvestments" },
                        { label: "Your Individual Contribution to NPS (maximum possible 10% of salary- basic+DA)", key: "individualContribution_NPS" },
                        // { label: "Life Insurance Premium", key: "lifeInsurancePremium" },
                        // { label: "ELSS Investments", key: "elssInvestments" },
                        // { label: "5-Year Fixed Deposit", key: "fiveYearFD" },
                        // { label: "PPF Contribution", key: "ppfContribution" }
                      ].map((item) => (
                        <>
                          <div className="col-md-12">
                            <label className="col-md-6">{item.label}</label>
                            <div className="col-md-3 tax-input" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                              <img src={rupee} className="rupee col-md-4" />
                              <input
                                type="number"
                                className="tax-i col-md-8"
                                disabled
                                value={selectedEmployee.eightyC?.[item.key] || 0}
                              />
                            </div>
                          </div>
                          <br /><br />
                        </>
                      ))}
                    </div>
                    <br /><br />

                    {/* 80D Deductions */}
                    <div className="col-md-12">
                      <h4><b><u>Section 80D Deductions (Medical Insurance)</u></b></h4>
                    </div>
                    <br />
                    <div className="contain">
                      {[
                        { label: "Payment for Medical Insurance Premium/CGHS (for non-senior citizens) *mode other than cash (Self, Dependent Children and Spouse)", key: "medicalInsurancePremium_NONSeniorCitizen" },
                        { label: "Payment for Medical Insurance Premium/CGHS (for non-senior citizens) *mode other than cash (Parents)", key: "medicalInsurancePremium_NONSeniorCitizen_Parents" },
                        { label: "Payment for Medical Insurance Premium (for senior citizens) (Self, Dependent Children and Spouse)", key: "medicalInsurancePremium_SeniorCitizen" },
                        { label: "Payment for Medical Insurance Premium (for senior citizens) (Parents)", key: "medicalInsurancePremium_SeniorCitizen_Parents" },
                        { label: "Payments for preventive health check-ups (Self, Dependent Children and Spouse)", key: "preventiveHealthCheckups" },
                        { label: "Payments for preventive health check-ups (Parents)", key: "preventiveHealthCheckups_Parents" },
                        { label: "Medical expenditure on the health of resident senior citizen and very senior citizen for whom no amount is paid to effect / keep in force an insurance on the health (mode of payment other than cash) (Self, Dependent Children and Spouse)", key: "medicalExpenditure" },
                        { label: "Medical expenditure on the health of resident senior citizen and very senior citizen for whom no amount is paid to effect / keep in force an insurance on the health (mode of payment other than cash) (Parents)", key: "medicalExpenditure_Parents" }
                      ].map((item) => (
                        <>
                          <div className="col-md-12">
                            <label className="col-md-6">{item.label}</label>
                            <div className="col-md-3 tax-input" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                              <img src={rupee} className="rupee col-md-4" />
                              <input
                                type="number"
                                className="tax-i col-md-8"
                                disabled
                                value={selectedEmployee.eightyD?.[item.key] || 0}
                              />
                            </div>
                          </div>
                          <br /><br />
                        </>
                      ))}
                    </div>
                    <br /><br />

                    {/* Other Deductions */}
                    <div className="col-md-12">
                      <h4><b><u>Other Deductions</u></b></h4>
                    </div>
                    <br />
                    <div className="contain">
                      {/* 80G */}
                      <div className="col-md-12">
                        <label className="col-md-6">80G- Donations</label>
                        <div className="col-md-3 tax-input" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                          <img src={rupee} className="rupee col-md-4" />
                          <input
                            type="number"
                            className="tax-i col-md-8"
                            disabled
                            value={selectedEmployee.eightyG?.donation || 0}
                          />
                        </div>
                      </div>
                      <br /><br />

                      {/* 80E */}
                      <div className="col-md-12">
                        <label className="col-md-6">80E- Interest on Education Loan</label>
                        <div className="col-md-3 tax-input" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                          <img src={rupee} className="rupee col-md-4" />
                          <input
                            type="number"
                            className="tax-i col-md-8"
                            disabled
                            value={selectedEmployee.eightyE?.interestON_educationLoan || 0}
                          />
                        </div>
                      </div>
                      <br /><br />

                      {/* 80EE */}
                      <div className="col-md-12">
                        <label className="col-md-6">80EE- Interest on residential property less than Rs 50 lakhs in value</label>
                        <div className="col-md-3 tax-input" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                          <img src={rupee} className="rupee col-md-4" />
                          <input
                            type="number"
                            className="tax-i col-md-8"
                            disabled
                            value={selectedEmployee.eightyEE?.intrestONLoan || 0}
                          />
                        </div>
                      </div>
                      <br /><br />

                      {/* 80U/80DD */}
                      <div className="col-md-12">
                        <label className="col-md-6">80U- Self Disability- Non-Severe (40-80%)</label>
                        <div className="col-md-3 tax-input" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                          <img src={rupee} className="rupee col-md-4" />
                          <input
                            type="number"
                            className="tax-i col-md-8"
                            disabled
                            value={selectedEmployee.eightyU_DD?.selfDisabilit || 0}
                          />
                        </div>
                      </div>
                      <br /><br />
                      <div className="col-md-12">
                        <label className="col-md-6">{'80U- Self Disability- Severe(>=80%)'}</label>
                        <div className="col-md-3 tax-input" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                          <img src={rupee} className="rupee col-md-4" />
                          <input
                            type="number"
                            className="tax-i col-md-8"
                            disabled
                            value={selectedEmployee.eightyU_DD?.amountSD || 0}
                          />
                        </div>
                      </div>
                      <br /><br />
                      <div className="col-md-12">
                        <label className="col-md-6">80DD- Dependent Disability- Non-Severe (40-80%)</label>
                        <div className="col-md-3 tax-input" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                          <img src={rupee} className="rupee col-md-4" />
                          <input
                            type="number"
                            className="tax-i col-md-8"
                            disabled
                            value={selectedEmployee.eightyU_DD?.dependentDisability || 0}
                          />
                        </div>
                      </div>
                      <br /><br />

                      <div className="col-md-12">
                        <label className="col-md-6">{'80DD - Dependent Disability - Severe (>=80%)'}</label>
                        <div className="col-md-3 tax-input" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                          <img src={rupee} className="rupee col-md-4" />
                          <input
                            type="number"
                            className="tax-i col-md-8"
                            disabled
                            value={selectedEmployee.eightyU_DD?.amountDD || 0}
                          />
                        </div>
                      </div>
                      <br /><br />

                      {/* 80CCG */}
                      <div className="col-md-12">
                        <label className="col-md-6">80CCG- First time Equity Investor with gross salary less than
                          Rs 12 lacks p.a. (50% of amount invested in selected schemes)</label>
                        <div className="col-md-3 tax-input" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                          <img src={rupee} className="rupee col-md-4" />
                          <input
                            type="number"
                            className="tax-i col-md-8"
                            disabled
                            value={selectedEmployee.eighyCCG?.amountInvested || 0}
                          />
                        </div>
                      </div>
                      <br /><br />

                      {/* 80DDB */}
                      <div className="col-md-12">
                        <label className="col-md-6">80DDB- Expenses on specified diseases for self/dependent</label>
                        <div className="col-md-3 tax-input" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                          <img src={rupee} className="rupee col-md-4" />
                          <input
                            type="number"
                            className="tax-i col-md-8"
                            disabled
                            value={selectedEmployee.eightyDDB?.expensesOnSpecifiedDiseases || 0}
                          />
                        </div>
                      </div>
                    </div>
                    <br /><br />

                    {/* House Property */}
                    <div className="col-md-12">
                      <h4><b><u>House Property Details</u></b></h4>
                    </div>
                    <br />
                    <div className="contain">
                      <div className="col-md-12">
                        <label className="col-md-6">Age</label>
                        <div className="col-md-3 tax-input">
                          <input
                            type="text"
                            className="tax-i col-md-12"
                            disabled
                            value={selectedEmployee.section?.age || 0}
                          />
                        </div>
                      </div>
                      <br /><br />

                      <div className="col-md-12 row">
                        <label className="col-md-2">Residence Type:</label>
                        <div className="col-md-2">
                          <input
                            type="radio"
                            disabled
                            checked={selectedEmployee.section?.isMetroCity === 1}
                          />
                          &nbsp; &nbsp;
                          <label>Metro City</label>
                        </div>
                        <div className="col-md-2">
                          <input
                            type="radio"
                            disabled
                            checked={selectedEmployee.section?.isMetroCity === 0}
                          />
                          &nbsp; &nbsp;
                          <label>Non-Metro City</label>
                        </div>
                      </div>
                      <br /><br />

                      <div className="col-md-12">
                        <label className="col-md-6">Annual Rent Paid/Home Loan Interest</label>
                        <div className="col-md-3 tax-input" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                          <img src={rupee} className="rupee col-md-4" />
                          <input
                            type="number"
                            className="tax-i col-md-8"
                            disabled
                            value={selectedEmployee.section?.rentORpropoerty || 0}
                          />
                        </div>
                      </div>
                    </div>
                    <br /><br />

                    {/* TDS Details */}
                    <div className="col-md-12">
                      <h4><b><u>TDS Details</u></b></h4>
                    </div>
                    <br />
                    <div className="contain">
                      <div className="col-md-12">
                        <label className="col-md-6">Annual TDS</label>
                        <div className="col-md-3 tax-input" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                          <img src={rupee} className="rupee col-md-4" />
                          <input
                            type="number"
                            className="tax-i col-md-8"
                            disabled
                            value={selectedEmployee.annual_tds || 0}
                          />
                        </div>
                      </div>
                      <br /><br />

                      <div className="col-md-12">
                        <label className="col-md-6">Monthly TDS</label>
                        <div className="col-md-3 tax-input" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                          <img src={rupee} className="rupee col-md-4" />
                          <input
                            type="number"
                            className="tax-i col-md-8"
                            disabled
                            value={selectedEmployee.monthly_tds || 0}
                          />
                        </div>
                      </div>
                    </div>

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                      <Button variant="contained" onClick={() => setModalOpen(false)}>
                        Close
                      </Button>
                    </Box>
                  </div>
                )}
              </Box>
            </Modal>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default EmployeeTaxDeclaration;